import nestedProperty from 'nested-property'
import _ from 'lodash'
export default {
  data: () => ({
    menu: false,
  }),
  computed: {
    classes () { return this.inPopup ? 'xs12' : this.field.classes || 'md3' },
    label () { return this.field.label },
    type () { return this.field.type },
    hint () { return this.field.hint },
    name () { return this.field.name },
    from () { return this.field.from },
    source () { return this.field.source },
    context () { return this.field.context ? this.field.context : { params: {} } },
    cascade () { return this.field.cascade },
    required () { return this.field.required ? this.field.required : false },
    disabled () { return this.field.disabled ? this.field.disabled : false },
    fieldValue: {
      get () {
        return nestedProperty.get(this.form.data, this.name)
      },
      set (value) {
        this.menu = false
        this.updateField({key: this.name, value})
      },
    },
    loading () {
      return this.source ? this.$store.getters[`${this.source}/isLoading`] : false
    },
    errorMessages () {
      return nestedProperty.get(this.form.errors, `errors.${this.name}`)
    },
  },
  props: {
    updateField: Function,
    form: Object,
    field: {
      type: Object,
      required: true,
    },
    inPopup: Boolean,
  },
  methods: {
    customFilter (item, queryText, itemText) {
      const hasValue = val => val != null ? val : ''
      const text = hasValue(item[this.from])
      const query = hasValue(queryText)
      return text.toString()
        .toLowerCase()
        .indexOf(query.toString().toLowerCase()) > -1
    },
  },
  beforeMount () {
    if (_.includes(['list', 'multilist'], this.field.type)) {
      let payload = {
        accessors: {},
        data: {},
        context: this.context,
      }
      this.$store.dispatch(`${this.source}/fetchAll`, payload)
    }
  },
}
